<script setup lang="ts">
import LandingTitleLayout from '../LandingTitleLayout.vue';
import AdvantageCard from '../AdvantageCard.vue';
import { type AdvantageItem } from '../../types';

const props = defineProps<{
  items: AdvantageItem[];
}>();
</script>

<template>
  <div class="container advantages">
    <LandingTitleLayout>
      <template #title>
        <slot name="title" />
      </template>
    </LandingTitleLayout>

    <div class="advantages__grid">
      <AdvantageCard
        v-for="(item, index) in props.items"
        :key="index"
        :icon-src="item.iconUrl"
        :title="item.title"
        :color="item.color"
      >
        {{ item.text }}
      </AdvantageCard>
    </div>
  </div>
</template>

<style scoped lang="scss">
.advantages {
  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;

    @include media-breakpoint-down(sm) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
